import 'dayjs/locale/pt-br';
import './StockCommission.scss';

import { faCheckCircle, faFileInvoiceDollar, faListAlt } from '@fortawesome/free-solid-svg-icons';
import { formatDate, formatDateInEN, formatInReal } from '../../commons/util/HallAppUtil';
import { useEffect, useState } from 'react';

import AppCard from '../../commons/cards/AppCard';
import AppLinkButton from '../../commons/buttons/AppLinkButton';
import AppLoading from '../../commons/AppLoading';
import ConfirmModal from '../../commons/modal/ConfirmModal';
import EmptyState from '../../commons/EmptyState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HallAppToast from '../../commons/HallAppToast';
import MultiDateFilterInput from '../../commons/inputs/MultiDateFilterInput';
import StockAPI from './StockAPI';
import { useNavigate } from 'react-router-dom';

const stockAPI = new StockAPI();

function StockCommission() {
  const [isLoading, setIsLoading] = useState(true);
  const [commissions, setCommissions] = useState([]);
  const [currentCommission, setCurrentCommission] = useState(null);
  const [showModalPayment, setShowModalPayment] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);

  const navigate = useNavigate();

  const endDate = new Date();
  const startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

  const [filter, setFilter] = useState({
    startDate: formatDateInEN(startDate),
    endDate: formatDateInEN(endDate),
  });

  useEffect(() => {
    callGetCommission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const callGetCommission = async () => {
    try {
      setIsLoading(true);
      const resp = await stockAPI.getCommission(filter);
      setCommissions(Array.isArray(resp.data) ? resp.data : []);
    } catch (_) {
      HallAppToast.genericError();
      setCommissions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmPayment = async () => {
    try {
      setShowLoadingModal(true);
      const data = {
        ...currentCommission,
        ...filter,
      };
      await stockAPI.confirmPayment(data);
      HallAppToast.success('Pagamento registrado com sucesso!');
      setShowModalPayment(false);
      setCurrentCommission(null);
      await callGetCommission(); // atualiza lista
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setShowLoadingModal(false);
    }
  };

  function changeDates(startDate, endDate) {
    if (endDate === null) {
      endDate = startDate;
    }
    setFilter({
      ...filter,
      startDate: startDate,
      endDate: endDate,
    });
  }

  return (
    <div className="container">
      <div className="stock-commission__filter">
        <MultiDateFilterInput startDate={startDate} endDate={endDate} changeDates={changeDates} />
      </div>

      {isLoading ? (
        <AppLoading />
      ) : commissions.length === 0 ? (
        <EmptyState
          title="Nenhuma comissão no período"
          description="Não há comissões registradas para o período selecionado. Ajuste o filtro de datas ou aguarde vendas de produtos com comissão."
          icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}
        />
      ) : (
        <div className="stock-commission__list">
          {commissions.map((data) => (
            <AppCard key={data.employeeId} className="stock-commission__card">
              <div className="stock-commission__header">
                <h5 className="stock-commission__name" title={data.employeeName}>
                  {data.employeeName}
                </h5>
              </div>

              <div className="stock-commission__body">
                <div className="stock-commission__row">
                  <span className="stock-commission__label">
                    Valor total ({formatDate(filter?.startDate)} a {formatDate(filter?.endDate)}):
                  </span>
                  <span className="stock-commission__value stock-commission__value--total">
                    {formatInReal(data?.totalCommission || 0)}
                  </span>
                </div>

                <div className="stock-commission__row">
                  <span className="stock-commission__label">Valor pendente:</span>
                  <span className="stock-commission__value stock-commission__value--pending">
                    {formatInReal(data?.totalCommissionPending || 0)}
                  </span>
                </div>

                {data?.totalCommissionPending > 0 && (
                  <p className="stock-commission__hint">
                    Verifique os detalhes para conferir comissões pendentes.
                  </p>
                )}
              </div>

              <div className="stock-commission__actions">
                <AppLinkButton
                  onClick={() => {
                    setCurrentCommission(data);
                    setShowModalPayment(true);
                  }}
                  width="100%"
                  name="Marcar como pago"
                  iconLeft={<FontAwesomeIcon icon={faCheckCircle} />}
                />
                <AppLinkButton
                  onClick={() => navigate(`/estoque/detalhes/profissional/${data.employeeId}`)}
                  width="100%"
                  name="Ver detalhes"
                  iconLeft={<FontAwesomeIcon icon={faListAlt} />}
                />
              </div>
            </AppCard>
          ))}
        </div>
      )}

      {showModalPayment && (
        <ConfirmModal
          show={showModalPayment}
          title="Confirmar pagamento"
          isLoading={showLoadingModal}
          textBtnConfirm='CONFIRMAR'
          confirm={confirmPayment}
          closeModal={() => {
            setCurrentCommission(null);
            setShowModalPayment(false);
          }}
        >
          <p>
            Deseja registrar o pagamento no valor de{' '}
            <strong>{formatInReal(currentCommission?.totalCommission || 0)}</strong> para o(a)
            profissional <strong>{currentCommission?.employeeName}</strong>?
          </p>
          <p style={{ fontSize: 13, color: '#6b7280', marginTop: 8 }}>
            Período: {formatDate(filter?.startDate)} a {formatDate(filter?.endDate)}
          </p>
        </ConfirmModal>
      )}
    </div>
  );
}

export default StockCommission;